import React from 'react';
import Popup from '../../../../../../components/common/popUp/PopUp';
import styles from './templateChoice.css';
import QuizIcon from '../../../../../../assets/svg/quiz.svg';
import CalendarIcon from '../../../../../../assets/svg/calendar.svg';
import PersonIcon from '../../../../../../assets/svg/account.svg';
import StudemtIcon from '../../../../../../assets/svg/school-24px.svg';

/**
 *
 * @type {React.NamedExoticComponent<{readonly content?: *, readonly handleToggleTemplateWizard?: *, readonly handleTemplateChoice?: *}>}
 */
const TemplateChoice = React.memo ( ( { handleToggleTemplateWizard, handleTemplateChoice, content } ) => (
    <Popup
        handleClose={ handleToggleTemplateWizard }
        windowStyle={ {
            minHeight: '60rem',
            maxHeight: '60%',
            width: '58%',
            borderRadius: '1rem',
            backgroundColor: '#fff',
            boxShadow: '0 2px 7.4rem 0 rgba(0, 0, 0, 0.11)'
        } }
    >
        <div className={ styles.wrapper }>
            <p className={ styles.title }>{ content.dashboard.select_template_continue }</p>
            <div className={ styles.templatesWrapper }>
                <div className={ styles.templateWrapper } onClick={ handleTemplateChoice ( 'quiz' ) }>
                    <QuizIcon className={ styles.templateIcon }/>
                    <span className={ styles.templateText }>{ content.dashboard.quiz_widget }</span>
                </div>

                <div className={ styles.templateWrapper } onClick={ handleTemplateChoice ( 'calendar' ) }>
                    <CalendarIcon className={ styles.templateIcon }/>
                    <span className={ styles.templateText }>{ content.dashboard.calendar_quiz }</span>
                </div>

                <div className={ styles.templateWrapper } onClick={ handleTemplateChoice ( 'person' ) }>
                    <PersonIcon className={ styles.templateIcon }/>
                    <span className={ styles.templateText }>{ content.dashboard.personality_test }</span>
                </div>
                <div className={ styles.templateWrapper } onClick={ handleTemplateChoice ( 'academy' ) }>
                    <StudemtIcon className={ styles.templateIcon }/>
                    <span className={ styles.templateText }>{ content.dashboard.academy_quiz_beta }</span>
                </div>
            </div>
        </div>
    </Popup>
) );

export default TemplateChoice;